<template>
  <div>
    <team-icon :team="team" />
    <span class="team-name-inner-element" @click="$emit('click')">
      {{ team.name }}
    </span>
  </div>
</template>

<script>
import TeamIcon from '@/components/Team/TeamIcon'

export default {
  components: {
    TeamIcon,
  },
  props: {
    team: Object,
    highlight: Boolean,
    hover: Boolean,
  },
}
</script>

<style lang="scss" scoped>
div {
  display: flex;
  align-items: center;

  .team-name-inner-element {
    @include font-rule('averta-bold');
    margin-left: 11px;
  }
}
</style>
